module.exports = __webpack_public_path__ + "assets/img/home-characterA.c8b9abfc.png";